import { render, staticRenderFns } from "./AvatarForm.vue?vue&type=template&id=78fe08be&scoped=true"
import script from "./AvatarForm.vue?vue&type=script&lang=js"
export * from "./AvatarForm.vue?vue&type=script&lang=js"
import style0 from "./AvatarForm.vue?vue&type=style&index=0&id=78fe08be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fe08be",
  null
  
)

export default component.exports